import { useEffect } from "react";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

export default function SEO({ title, description, path = "/" }) {
  useEffect(() => {
    const fullTitle = `${title} | NextMove Removalists Australia`;
    document.title = fullTitle;
    upsert('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "description");
      return m;
    }).setAttribute("content", description);
    upsert('meta[property="og:title"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:title");
      return m;
    }).setAttribute("content", fullTitle);
    upsert('meta[property="og:description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:description");
      return m;
    }).setAttribute("content", description);
    upsert('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }).setAttribute("href", window.location.origin + path);
  }, [title, description, path]);
  return null;
}
